import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./style.css";

const Bar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [summerDropdownOpen, setSummerDropdownOpen] = useState(false);
  const [mobileSummerOpen, setMobileSummerOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Close desktop dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setSummerDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const specialProgramsMap = {
    "/field-days": "Field Days",
    "/school-programs": "School Programs",
    "/after-school-programs": "After School Programs",
    "/summer-camp": "Summer Camp",
    "/fundraising": "Fundraising",
    "/equipment-apparel": "Equipment Apparel",
  };

  const currentLabel =
    specialProgramsMap[location.pathname] || "Special Programs";

  const summerCampLinks = [
    { label: "Ultimate Summer Camp", link: "https://summercamp.bwcsports.com/" },
    { label: "Baseball Camp", link: "https://summercamp.bwcsports.com/bwc-baseball-camp-2026" },
  ];

  const navItems = [
    { label: "Field Days", link: "/field-days" },
    { label: "School Programs", link: "/school-programs" },
    { label: "After School Programs", link: "/after-school-programs" },
    { label: "Summer Camp", link: null, dropdown: summerCampLinks },
    { label: "Fundraising", link: "/fundraising" },
    { label: "Equipment Apparel", link: "/equipment-apparel" },
  ];

  return (
    <nav className="navbar">
      {/* Desktop nav */}
      <div className="nav-items">
        {navItems.map((item, index) =>
          item.dropdown ? (
            <div
              key={index}
              className="nav-dropdown-wrapper"
              ref={dropdownRef}
            >
              <button
                className="nav-dropdown-trigger"
                onClick={() => setSummerDropdownOpen((prev) => !prev)}
                aria-expanded={summerDropdownOpen}
              >
                {item.label}
                <i
                  className={
                    summerDropdownOpen
                      ? "ri-arrow-drop-up-line"
                      : "ri-arrow-drop-down-line"
                  }
                  style={{ fontSize: "20px", marginLeft: "2px" }}
                ></i>
              </button>
              {summerDropdownOpen && (
                <div className="nav-dropdown-menu">
                  {item.dropdown.map((sub, si) => (
                    <a
                      key={si}
                      href={sub.link}
                      onClick={() => setSummerDropdownOpen(false)}
                    >
                      {sub.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <a key={index} href={item.link}>
              {item.label}
            </a>
          )
        )}
      </div>

      {/* Hamburger toggle (mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        <p>
          {currentLabel}{" "}
          {isOpen ? (
            <i style={{ fontSize: "28px" }} className="ri-arrow-drop-up-line"></i>
          ) : (
            <i style={{ fontSize: "28px" }} className="ri-arrow-drop-down-line"></i>
          )}
        </p>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        {navItems.map((item, index) =>
          item.dropdown ? (
            <div key={index} className="mobile-dropdown-wrapper">
              <button
                className="mobile-dropdown-trigger"
                onClick={() => setMobileSummerOpen((prev) => !prev)}
              >
                {item.label}
                <i
                  className={
                    mobileSummerOpen
                      ? "ri-arrow-drop-up-line"
                      : "ri-arrow-drop-down-line"
                  }
                  style={{ fontSize: "22px", marginLeft: "4px" }}
                ></i>
              </button>
              {mobileSummerOpen && (
                <div className="mobile-dropdown-submenu">
                  {item.dropdown.map((sub, si) => (
                    <a
                      key={si}
                      href={sub.link}
                      onClick={() => {
                        setIsOpen(false);
                        setMobileSummerOpen(false);
                      }}
                    >
                      {sub.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <a key={index} href={item.link} onClick={() => setIsOpen(false)}>
              {item.label}
            </a>
          )
        )}
      </div>
    </nav>
  );
};

export default Bar;
